import { Panel } from 'foundations-components/transitional/components/Panel';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { H2 } from 'foundations-components/transitional/components/H2';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { ErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import { useState } from 'react';
import { PanelFooter } from 'foundations-components/transitional/components/PanelFooter';
import { PanelBody } from 'foundations-components/transitional/components/PanelBody';
import { PanelHeader } from 'foundations-components/transitional/components/PanelHeader';
import { Loadable } from 'foundations-components/transitional/utils/Loadable';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const PanelLoadingComponent = () => {
  const [isMounted, setIsMounted] = useState(true);
  if (!isMounted) {
    return null;
  }
  const close = () => setIsMounted(false);
  return /*#__PURE__*/_jsxs(Panel, {
    children: [/*#__PURE__*/_jsxs(PanelHeader, {
      children: [/*#__PURE__*/_jsx(DialogCloseButton, {
        onClick: close
      }), /*#__PURE__*/_jsx(H2, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "bulkActions.modals.loadingModal.title"
        })
      })]
    }), /*#__PURE__*/_jsx(PanelBody, {
      children: /*#__PURE__*/_jsx(LoadingSpinner, {
        layout: "centered"
      })
    }), /*#__PURE__*/_jsx(PanelFooter, {})]
  });
};
export const DefaultLoadingComponent = () => {
  const [isMounted, setIsMounted] = useState(true);
  if (!isMounted) {
    return null;
  }
  const close = () => setIsMounted(false);
  return /*#__PURE__*/_jsxs(Modal, {
    children: [/*#__PURE__*/_jsxs(DialogHeader, {
      children: [/*#__PURE__*/_jsx(DialogCloseButton, {
        onClick: close
      }), /*#__PURE__*/_jsx(H2, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "bulkActions.modals.loadingModal.title"
        })
      })]
    }), /*#__PURE__*/_jsx(DialogBody, {
      children: /*#__PURE__*/_jsx(LoadingSpinner, {
        layout: "centered"
      })
    }), /*#__PURE__*/_jsx(DialogFooter, {})]
  });
};
export const DefaultErrorComponent = () => {
  const [isMounted, setIsMounted] = useState(true);
  if (!isMounted) {
    return null;
  }
  const close = () => setIsMounted(false);
  return /*#__PURE__*/_jsxs(Modal, {
    children: [/*#__PURE__*/_jsxs(DialogHeader, {
      children: [/*#__PURE__*/_jsx(DialogCloseButton, {
        onClick: close
      }), /*#__PURE__*/_jsx(H2, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "bulkActions.modals.errorModal.title"
        })
      })]
    }), /*#__PURE__*/_jsx(DialogBody, {
      children: /*#__PURE__*/_jsx(ErrorMessage, {
        type: "badRequest"
      })
    })]
  });
};
export const makeCodeSplitModal = ({
  importResult,
  LoadingComponent = DefaultLoadingComponent,
  ErrorComponent = DefaultErrorComponent
}) => Loadable({
  loader: importResult,
  LoadingComponent,
  ErrorComponent
});